export const ADVANCED_FILTER_KEYS = ["roles", "tools", "packages"] as const;

export type AdvancedFilterKey = (typeof ADVANCED_FILTER_KEYS)[number];

export interface FilterConfig {
  enabledFilters: ReadonlyArray<AdvancedFilterKey>;
}

export const PROJECT_USERS_FILTER_CONFIG: FilterConfig = {
  enabledFilters: ["tools", "roles"] as const,
} as const;

export const ADMIN_USERS_FILTER_CONFIG: FilterConfig = {
  enabledFilters: ["packages", "tools", "roles"] as const,
} as const;
